// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"c8006eea","784":"9263d649","910":"ded96dad"}[chunkId] + ".chunk.css";
};